import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

import { API_URL } from '../attrs/settings';
import { getReplacementTokensForSameUser } from './refreshTokenSession';

function getAccessToken() {
  return localStorage.getItem('accessToken');
}

function getRefreshToken() {
  return localStorage.getItem('refreshToken');
}

const instance = axios.create({
  baseURL: API_URL
});

const refreshInstance = axios.create({
  baseURL: API_URL
});

// Function that will be called to refresh authorization
const refreshAuthLogic = failedRequest => {
  const refreshToken = getRefreshToken();

  return refreshInstance
    .get('/v1/tokens', {
      headers: {
        Authorization: `Bearer ${refreshToken}`
      }
    })
    .then(tokenRefreshResponse => {
      localStorage.setItem('accessToken', tokenRefreshResponse.data.access);
      localStorage.setItem('refreshToken', tokenRefreshResponse.data.refresh);
      failedRequest.response.config.headers.Authorization = `Bearer ${tokenRefreshResponse.data.access}`;

      return Promise.resolve();
    })
    .catch(error => {
      const currentAccessToken = getAccessToken();
      const currentRefreshToken = getRefreshToken();
      const replacementTokens = getReplacementTokensForSameUser(
        refreshToken,
        currentAccessToken,
        currentRefreshToken
      );

      if (replacementTokens) {
        failedRequest.response.config.headers.Authorization = `Bearer ${replacementTokens.access}`;
        return Promise.resolve();
      }

      // Another tab may already have rotated this single-use refresh token.
      // Only invalidate the session when the failed token is still current.
      if (currentRefreshToken === refreshToken) {
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('accessToken');

        if (window.location.pathname !== '/login') {
          window.location.replace('/login?reason=session-expired');
        }
      }

      return Promise.reject(error);
    });
};

instance.interceptors.request.use(request => {
  request.headers.Authorization = `Bearer ${getAccessToken()}`;

  if (!!request && !!request.params) {
    Object.keys(request.params).map(filter => {
      if (request.params[filter] === '') {
        delete request.params[filter];
      }
      return request;
    });
  }
  return request;
});

createAuthRefreshInterceptor(instance, refreshAuthLogic, {
  statusCodes: [401, 403]
});

export default instance;
